<template>
  <div
    class="input"
    :class="{
      error: vErrors.length > 0 || isError,
      'with-copy': canCopy,
    }"
  >
    <div class="input__inner">
      <div class="input__title">
        {{ title }}
      </div>

      <input
        :type="type"
        class="input__el"
        :title="title"
        :disabled="disabled"
        v-model="text"
        @input="processInput"
        @focus="processFocus"
        @blur="processBlur"
        @keypress.enter="$emit('enter')"
        v-if="!mask"
        ref="inputEl"
        :placeholder="placeholder"
      />
      <input
        :type="type"
        class="input__el"
        :title="title"
        :disabled="disabled"
        v-model="text"
        @input="processInput"
        @focus="processFocus"
        @blur="processBlur"
        @keypress.enter="$emit('enter')"
        v-mask="mask"
        v-else
        ref="inputEl"
        :placeholder="placeholder"
      />

      <div class="input__copy" v-if="canCopy" @click="copyToClipboard">
        <svg
          width="31"
          height="30"
          viewBox="0 0 31 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <ellipse cx="15.8825" cy="15" rx="15.0519" ry="15" fill="#DBE7FD" />
          <path
            d="M10.9928 9.97028L10.9907 11.5625V19.4407C10.9907 20.7868 12.0858 21.8782 13.4366 21.8782L19.9212 21.8784C19.6887 22.5337 19.0615 23.0032 18.3243 23.0032H13.4366C11.4623 23.0032 9.86182 21.4082 9.86182 19.4407V11.5625C9.86182 10.827 10.334 10.2013 10.9928 9.97028ZM20.21 8C21.1452 8 21.9033 8.75552 21.9033 9.6875V19.4375C21.9033 20.3695 21.1452 21.125 20.21 21.125H13.4366C12.5014 21.125 11.7433 20.3695 11.7433 19.4375V9.6875C11.7433 8.75552 12.5014 8 13.4366 8H20.21ZM20.21 9.125H13.4366C13.1249 9.125 12.8722 9.37684 12.8722 9.6875V19.4375C12.8722 19.7482 13.1249 20 13.4366 20H20.21C20.5217 20 20.7744 19.7482 20.7744 19.4375V9.6875C20.7744 9.37684 20.5217 9.125 20.21 9.125Z"
            fill="#64748B"
          />
        </svg>
      </div>
    </div>

    <div class="input__hint">
      {{ hint }}
    </div>
    <div class="input__errors" v-if="vErrors.length > 0">
      <div class="input__error">{{ vErrors[0].$message }}</div>
    </div>
  </div>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../utils/gogocodeTransfer'
export default {
  name: 'LinkInput',
  model: {
    prop: 'value',
    event: 'update',
  },
  props: {
    title: {
      type: [String, Number],
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: null,
    },
    value: [String, Number],
    hint: {
      type: String,
      default: '',
    },
    closeButton: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    vErrors: {
      type: Array,
      default() {
        return []
      },
    },
    isError: {
      type: Boolean,
      default: false,
    },
    mask: {
      type: [String, Object, Function],
      default: null,
    },
    canCopy: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      text: '',
      isFocused: false,
    }
  },
  created() {
    this.text = this.value === 0 ? this.value : this.value || ''
  },
  mounted() {
    this.$emit('canFocus', this)
  },
  computed: {
    isLabelToTop: function () {
      return (this.text ? this.text.length > 0 : false) || this.isFocused
    },
  },
  watch: {
    value: function () {
      this.text = this.value
    },
  },
  methods: {
    checkAnimation(e) {
      if (e.animationName === 'onAutoFillStart') {
        this.text = this.text + ' '
        this.autofilled = true
      } else if (e.animationName === 'onAutoFillCancel') {
        this.text = this.text + ' '
        this.autofilled = false
      }
    },

    processFocus() {
      this.$emit('textInputFocus')
      this.isFocused = true
    },
    processBlur() {
      this.$emit('textInputBlur')
      this.isFocused = false
    },
    processInput() {
      this.$emit('update:value', this.text)
    },
    copyToClipboard() {
      if (!navigator.clipboard) {
        return
      }

      navigator.clipboard.writeText(this.text).then(
        () => {
          $emit(this, 'copied')
        },
        (err) => {
          console.error('Async: Could not copy text: ', err)
        }
      )
    },
    focus() {
      this.$refs.inputEl.focus()
    },
  },
  emits: [
    'enter',
    'canFocus',
    'update',
    'textInputFocus',
    'textInputBlur',
    'copied',
    'update:value',
  ],
}
</script>

<style lang="scss" scoped>
.input {
  width: 100%;
  position: relative;
  &.with-copy & {
    &__el {
      padding-right: 60px;
    }
  }

  &__title {
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    color: #465a8b;
    padding: 2px 16px;
    position: absolute;
    top: 0;
    left: 17px;

    transform: translateY(-50%);
    background-color: #fff;
  }

  &__el {
    width: 100%;
    border: 1px solid #e0e6f2;
    background-color: transparent;
    border-radius: 6px;
    padding: 24px 15px 24px 21px;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #64748B;
    outline: none;

    &:focus,
    &:active {
      border-color: #64748B;
    }

    //&:disabled {
    //  border-color: #eee;
    //}
  }

  &__hint {
    margin-top: 4px;
    font-weight: 500;
    font-size: 10px;
    line-height: 14px;
    color: #b9c4d8;
  }

  &__copy {
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translateY(-50%);

    width: 30px;
    height: 30px;

    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }

    svg {
      width: 100%;
      height: 100%;
    }
  }

  &__inner {
    position: relative;
  }
}
</style>

<style>
:-webkit-autofill {
  animation-name: onAutoFillStart;
}
:not(:-webkit-autofill) {
  animation-name: onAutoFillCancel;
}
@keyframes onAutoFillStart {
  from {
  }
  to {
  }
}
@keyframes onAutoFillCancel {
  from {
  }
  to {
  }
}
</style>
